import { PartnersService } from 'src/app/_services/partners.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessService } from 'src/app/_services/mess-service.service';

@Component({
  selector: 'app-partner-edit-improved',
  templateUrl: './partner-edit-improved.component.html',
  styleUrls: ['./partner-edit-improved.component.scss'],
})
export class PartnerEditImprovedComponent implements OnInit, OnDestroy {
  form: FormGroup;
  subscriptions: Subscription[] = [];
  id: number;
  loading = false;
  constructor(
    private partnerService: PartnersService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private messService: MessService
  ) {}

  /* ====================================
     *              LIFECYCLES
     ======================================= */
  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];

    this.form = this.fb.group({
      code: ['', Validators.required],
      company: ['', Validators.required],
      contact: [''],
      address: [''],
      email: [''],
      phone: [''],
      note: [''],
    });
    this.getData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
     *             MAIN FEATURES
     ======================================= */

  getData() {
    this.loading = true;
    this.subscriptions.push(
      this.partnerService.getOne(this.id).subscribe({
        next: (response: any) => {
          this.form.patchValue({
            code: response?.data?.code,
            company: response?.data?.company,
            contact: response?.data?.contact,
            address: response?.data?.address,
            email: response?.data?.email,
            phone: response?.data?.phone,
            note: response?.data?.note,
          });

          this.loading = false;
        },
        error: (err: any) => {
          this.loading = false;
        },
      })
    );
  }

  onSubmit() {
    this.loading = true;
    const form = this.form.getRawValue();

    this.subscriptions.push(
      this.partnerService.updatePartner(this.id, form).subscribe(
        () => {
          this.loading = false;
          this.messService.add({
            severity: 'success',
            title: 'Uspešno ažuriranje',
            detail: 'Ažurirali ste partnera.',
          });
          this.router.navigate(['./../../'], { relativeTo: this.route });
        },
        (error) => {
          this.loading = false;

          const errorObj = error.error.errors;
          const form = this.form;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }
}
